// import components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// import hooks
import { useGetDutyHistoryPeriodsColumns } from '../hooks/useGetDutyHistoryPeriodsColumns';
import useGetDutyLinesPeriodsAudit from '../hooks/useGetDutyLinesPeriodsAudit';

// import types
import { DutyHistoryAuditProps } from './DutyHistoryAudit.types';

const DutyHistoryPeriodsAudit = ({
  isOpen,
  row,
  employeeId
}: DutyHistoryAuditProps) => {
  const columns = useGetDutyHistoryPeriodsColumns();
  const { data: dutyLinePeriodsAudit } = useGetDutyLinesPeriodsAudit(
    {
      employeeId,
      requestId: row?.dutyLineId
    },
    {
      enabled: !!isOpen && !!employeeId && !!row?.requestId
    }
  );

  if (!row && !dutyLinePeriodsAudit) return null;

  return (
    <TableCRUDLayout
      getRowId={(row) => row?.audit?.auditId}
      columns={columns}
      rows={dutyLinePeriodsAudit ?? []}
      disableActions
      pageSize={10}
    />
  );
};

export default DutyHistoryPeriodsAudit;
